import { Warning } from "@mui/icons-material"
import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
interface Props{
    deleteDialogOpen: boolean;
    setDeleteDialogOpen: (open: boolean) => void;
    apartmentById: any;
    handleDelete: () => void;
}
export const DeleteApartmentDialog = ({ deleteDialogOpen, setDeleteDialogOpen, apartmentById, handleDelete }: Props) => {
    return (
        <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogContent sx={{ textAlign: 'center', p: 4 }}>
          <Warning sx={{ fontSize: 60, color: '#FF9800', mb: 2 }} />
          <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
            ¿Eliminar Apartamento?
          </Typography>
          <Typography color="text.secondary">
            Esta acción no se puede deshacer. Se eliminará toda la información del apartamento {apartmentById?.apartmentNumber}.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleDelete} variant="contained" color="error">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    )
}